export const ADD_ARTICLE = 'ADD_ARTICLE';
export const INC_COUNTER = 'INC_COUNTER';
export const DEC_COUNTER = 'DEC_COUNTER';
export const DATA_LOADED = 'DATA_LOADED';
// register
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCSESS = 'REGISTER_SUCCSESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
// login
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCSESS = 'LOGIN_SUCCSESS';
export const LOGIN_ERROR = 'LOGLOGIN_ERRORIN';
export const CLEAR_LOGIN_DATA = 'CLEAR_LOGIN_DATA';
// authenticating
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCSESS = 'AUTH_SUCCSESS';
export const AUTH_ERROR = 'AUTH_ERROR';
// get transaction
export const TRANS_REQUEST = 'TRANS_REQUEST';
export const TRANS_SUCCSESS = 'TRANS_SUCCSESS';
export const TRANS_ERROR = 'TRANS_ERROR';
// update transaction
export const TRANS_UPDATE_REQUEST = 'TRANS_UPDATE_REQUEST';
export const TRANS_UPDATE_SUCCSESS = 'TRANS_UPDATE_SUCCSESS';
export const TRANS_UPDATE_ERROR = 'TRANS_UPDATE_ERROR';
// logout
export const LOGOUT_USER = 'LOGOUT_USER';
// upgrade subscribe
export const UPGRADE_REQUEST = 'UPGRADE_REQUEST';
export const UPGRADE_SUCCSESS = 'UPGRADE_SUCCSESS';
export const UPGRADE_ERROR = 'UPGRADE_ERROR';
export const CLEAR_UPGRADE_MESSAGE = 'CLEAR_UPGRADE_MESSAGE';
export const CLEAR_UPGRADE_ERROR = 'CLEAR_UPGRADE_ERROR';
// open close modal register and login
export const OPEN_MODAL_REGISTER = 'OPEN_MODAL_REGISTER';
export const CLOSE_MODAL_REGISTER = 'CLOSE_MODAL_REGISTER';
export const OPEN_MODAL_LOGIN = 'OPEN_MODAL_LOGIN';
export const CLOSE_MODAL_LOGIN = 'CLOSE_MODAL_LOGIN';
// Get type
export const GET_TYPES_REQUEST = 'GET_TYPES_REQUEST';
export const GET_TYPES_SUCCSESS = 'GET_TYPES_SUCCSESS';
export const GET_TYPES_ERROR = 'GET_TYPES_ERROR';
// Post new artist
export const POST_ARTIST_ERROR = 'POST_ARTIST_ERROR';
export const POST_ARTIST_REQUEST = 'POST_ARTIST_REQUEST';
export const POST_ARTIST_SUCCSESS = 'POST_ARTIST_SUCCSESS';
export const CLEAR_ERROR_ARTIST = 'CLEAR_ERROR_ARTIST';
export const CLEAR_MESSAGE_ARTIST = 'CLEAR_MESSAGE_ARTIST';
// Get artist
export const GET_ARTIST_ERROR = 'GET_ARTIST_ERROR';
export const GET_ARTIST_REQUEST = 'GET_ARTIST_REQUEST';
export const GET_ARTIST_SUCCSESS = 'GET_ARTIST_SUCCSESS';
// Artist by song
export const GET_ARTIST_BY_SONG_REQUEST = 'GET_ARTIST_BY_SONG_REQUEST';
export const GET_ARTIST_BY_SONG_SUCCESS = 'GET_ARTIST_BY_SONG_SUCCESS';
export const GET_ARTIST_BY_SONG_ERROR = 'GET_ARTIST_BY_SONG_ERROR';
export const CLEAR_ARTIST_DATA_AND_MODAL = 'CLEAR_ARTIST_DATA_AND_MODAL';

// SONGS
export const GET_SONGS_REQUEST = 'GET_SONGS_REQUEST';
export const GET_SONGS_SUCCSESS = 'GET_SONGS_SUCCSESS';
export const GET_SONGS_ERROR = 'GET_SONGS_ERROR';
// search songs
export const SEARCH_SONGS_REQUEST = 'SEARCH_SONGS_REQUEST';
export const SEARCH_SONGS_SUCCESS = 'SEARCH_SONGS_SUCCESS';
export const SEARCH_SONGS_ERROR = 'SEARCH_SONGS_SUCCESS';
//UPDATE SONGS
export const UPDATE_SONGS_REQUEST = 'UPDATE_SONGS_REQUEST';
export const UPDATE_SONGS_SUCCSESS = 'UPDATE_SONGS_SUCCSESS';
export const UPDATE_SONGS_ERROR = 'UPDATE_SONGS_ERROR';
// Delete Song
export const DELETE_SONGS_REQUEST = 'DELETE_SONGS_REQUEST';
export const DELETE_SONGS_SUCCSESS = 'DELETE_SONGS_SUCCSESS';
export const DELETE_SONGS_ERROR = 'DELETE_SONGS_ERROR';
export const CLEAR_DELETE_SONG_MESSAGE = 'CLEAR_DELETE_SONG_MESSAGE';
export const CLEAR_DELETE_SONG_ERROR = 'CLEAR_DELETE_SONG_ERROR';
// Modal Update Song
export const OPEN_MODAL_UPDATE_SONG = 'OPEN_MODAL_UPDATE_SONG';
export const CLOSE_MODAL_UPDATE_SONG = 'CLOSE_MODAL_UPDATE_SONG';
// Songs by artist
export const GET_SONGS_BY_ARTIST_REQUEST = 'GET_SONGS_BY_ARTIST_REQUEST';
export const GET_SONGS_BY_ARTIST_SUCCESS = 'GET_SONGS_BY_ARTIST_SUCCESS';
export const GET_SONGS_BY_ARTIST_ERROR = 'GET_SONGS_BY_ARTIST_ERROR';
// Add Song
export const POST_SONGS_REQUEST = 'POST_SONGS_REQUEST';
export const POST_SONGS_SUCCSESS = 'POST_SONGS_SUCCSESS';
export const POST_SONGS_ERROR = 'POST_SONGS_ERROR';
export const CLEAR_MESSAGE_ADD_SONG = 'CLEAR_MESSAGE_ADD_SONG';
export const CLEAR_ERROR_ADD_SONG = 'CLEAR_ERROR_ADD_SONG';
// Detail song
export const GET_DETAIL_SONG_ERROR = 'GET_DETAIL_SONG_ERROR';
export const GET_DETAIL_SONG_REQUEST = 'GET_DETAIL_SONG_REQUEST';
export const GET_DETAIL_SONG_SUCCSESS = 'GET_DETAIL_SONG_SUCCSESS';
export const CLEAR_DETAIL_SONG_SUCCSESS = 'CLEAR_DETAIL_SONG_SUCCSESS';
